import "./gallery.css";
import { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import { assetsMap, imageInitializer } from "../../model/assets";
import flipIcon from "../../assets/flip.svg";
import animIcon from "../../assets/anim.svg";
import timeline from "../../assets/timeline.svg";

const Gallery = () => {
    const [elements, setElements] = useState(Object.entries(assetsMap).filter(i => i[1].name));
    useEffect(() => {
        let timeout = imageInitializer(setElements, "name");
        return () => {
            clearTimeout(timeout);
        }
    }, [elements, setElements]);
    return (
        <div className="view">
            <Link to={"../portfolio"}><button className="reveal reveal-area action top left round align-center"><img draggable="false" alt="" width="35" height="35" src="https://saison.one/assetsCommon/navigation_arrow.svg"/></button></Link>
            <h2 className="view-title"><FormattedMessage id="gallery"/></h2>
            <div className="art-container reveal-area align-center">
                {elements.map((value, index) => <Link key={ index } to={ `./view?id=${value[0]}` }>
                    <button className="invisible reveal" style={{ animationDelay: index / (1.8 * elements.length) + "s", backgroundImage: `url(${ value[1].thumbnail })`, backgroundSize: value[1].tile || "cover", backgroundColor: assetsMap.busy ? "black" : value[1].colorTheme ? value[1].colorTheme : "" }}>
                        {value[1].sideB && <img draggable="false" className="manyIcon round" height="18" alt="" src={flipIcon}/>}
                        {(value[1].video || value[1].file.endsWith(".gif")) && <img draggable="false" className="manyIcon round" height="18" alt="" src={animIcon}/>}
                    </button>
                </Link>)}
            </div>
            <Link to={"../timeline"}><button className="reveal reveal-area action bottom left round align-center"><img draggable="false" alt="" width="35" height="35" src={ timeline }/></button></Link>
        </div>
    );
}

export default Gallery;